<section fxLayout="row" fxLayoutAlign="center start">
  <div fxFlex="300px" class="loginContainer" fxLayout="column" fxLayoutAlign="start center">
    <div fxFlex="60px" fxHide.lt-md></div>
    <h1>404 - Seite nicht gefunden!</h1>
    <p class="text-login">Diese Seite konnte nicht gefunden werden.</p>

    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <button class="button yellow" type="submit" color="primary" routerLink="/">Zurück zum Start</button>
    </div>

    <div fxFlex="60px"></div>
    <img src="../../../../../assets/img/semmily-logo-dark.png" width="73"/>
  </div>
</section>
